<template>
  <div>
    <button
      v-on="listeners"
      v-bind="attrs"
      :type="type"
      :class="[custom, sizeClasses, modeClasses, isLoading, { disabled: disabled, 'has-group': group }]"
      class="cbutton"
      :disabled="disabled"
      :aria-label="focusable ? ariaLabel : null"
      :tabindex="focusable ? 0 : -1"
      :aria-hidden="!focusable"
      >
      <base-icon
        :name="name"
        :size="iconSize"
        :title="titleIcon"
      />
    </button>
  </div>
</template>

<script>
export default {
  name: 'base-button-icon',
  props: {
    type: {
      type: String,
      default: 'button'
    },
    name: {
      type: String,
      require: true
    },
    mode: {
      type: String,
      default: 'primary-phantom'
    },
    iconSize: {
      type: String,
      default: 'md'
    },
    size: {
      type: String,
      default: 'lg'
    },
    custom: {
      type: [String, Object],
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: null,
    },
    titleIcon: {
      type: String,
      default: '',
    },
    focusable: {
      type: Boolean,
      default: true
    },
    group: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    listeners: function () {
      return {
        ...this.$listeners
      }
    },
    attrs: function () {
      return {
        ...this.$attrs
      }
    },
    isLoading: function () {
      return { 'loader-in-element': this.loading }
    },
    sizeClasses: function () {
      return {
        'w-8 h-8': this.size === 'xs',
        'w-10/5 h-10/5': this.size === 'md',
        'h-11 w-11': this.size === 'lg',
        'h-12 w-12': this.size === 'xl',
        'h-14 w-14': this.size === 'xxl',
      }
    },
    modeClasses: function () {
      return {
        'cbutton--primary': this.mode === 'primary',
        'cbutton--staticprimary': this.mode === 'staticprimary',
        'cbutton--secondary': this.mode === 'secondary',
        'cbutton--prim-phantom': this.mode === 'primary-phantom',
        'cbutton--staticprim-phantom': this.mode === 'staticprimary-phantom',
        'cbutton--sec-phantom': this.mode === 'secondary-phantom',
        'cbutton--prim-line': this.mode === 'primary-line',
        'cbutton--tools': this.mode === 'tools',
        'cbutton--core': this.mode === 'core',
        'cbutton--sec-phantom-blue': this.mode === 'secondary-phantom-blue',
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/scss/BaseButton.scss";
  .cbutton {
    @apply rounded-full cursor-pointer focus:ring-0;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    &:active:not(.disabled) {
      transform: scale(0.9);
    }
    &:focus {
      outline: 2px solid transparent !important;
      outline-offset: initial !important;
    }
    &.disabled {
      cursor: not-allowed !important;
    }
    &.cbutton--primary {
      @apply text-white bg-primary;
      &:focus-visible, &:hover {
        @apply bg-primary-500;
      }
      &:focus:not(:focus-visible) {
        @apply bg-primary;
      }
      &:active:not(.disabled) {
        @apply bg-primary-800;
      }
    }
    &.cbutton--staticprimary {
      @apply text-white bg-staticprimary;
      &:focus-visible, &:hover {
        @apply bg-staticprimary-500;
      }
      &:focus:not(:focus-visible) {
        @apply bg-staticprimary;
      }
      &:active:not(.disabled) {
        @apply bg-staticprimary-800;
      }
    }
    &.cbutton--core {
      &:focus-visible, &:hover, &:focus {
        @apply bg-primary-50 text-primary dark:bg-darkblue-600 dark:text-primary font-normal;
      }
    }
    &.cbutton--secondary {
      &:focus-visible, &:hover, &:focus {
        @apply bg-secondary-500 dark:bg-darkblue-500;
      }
    }
    &.cbutton--prim-phantom {
      @apply bg-primary-50 dark:bg-darkblue text-primary;
    }
    &.cbutton--sec-phantom-blue {
      &:focus-visible, &:hover, &:focus {
        @apply bg-primary-600 dark:bg-primary-600;
      }
    }
  }
</style>
